import React, { useState } from 'react';
import { useModalA11y } from '../utils/useModalA11y';

function LockIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
    );
}

/**
 * Lightweight local password modal for locked PDFs.
 */
export default function PasswordModal({ title, message, onSubmit, onCancel }) {
    const [pwd, setPwd] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    useModalA11y({ onClose: onCancel, isOpen: true });

    return (
        <div
            className="sp-modal-overlay"
            style={{ zIndex: 1200 }}
            role="presentation"
            onClick={onCancel}
        >
            <div
                className="sp-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="pwd-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="sp-modal-head">
                    <div className="sp-modal-icon" aria-hidden="true">
                        <LockIcon />
                    </div>
                    <div className="sp-modal-head-text">
                        <h3 id="pwd-modal-title">{title}</h3>
                        <p className="sp-modal-message">
                            {message || 'Statement is locked. Enter password (processed only on this phone).'}
                        </p>
                    </div>
                </div>

                <label className="sp-field-label" htmlFor="pdf-password-input">PDF password</label>
                <div className="sp-password-field">
                    <input
                        id="pdf-password-input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && pwd) onSubmit(pwd);
                        }}
                        autoFocus
                        autoComplete="current-password"
                        className="sp-input"
                    />
                    <button
                        type="button"
                        className="sp-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        {showPassword ? 'Hide' : 'Show'}
                    </button>
                </div>

                <div className="sp-modal-actions">
                    <button type="button" className="sp-btn-ghost" onClick={onCancel}>Cancel</button>
                    <button
                        type="button"
                        className="sp-btn-primary"
                        disabled={!pwd}
                        onClick={() => { if (pwd) onSubmit(pwd); }}
                    >
                        Unlock PDF
                    </button>
                </div>
            </div>
        </div>
    );
}
